import React from "react";
import Box from "@mui/material/Box";
import FileUploadIcon from "@mui/icons-material/FileUpload";
import CancelIcon from "@mui/icons-material/Cancel";

export default function UploadPrescription({ uploadedFiles, setUploadedFiles }) {
  const onFileUpload = async (event) => {
    const { files } = event.target;

    setUploadedFiles([...uploadedFiles, ...Object.values(files)]);
  };

  const removeFile = async (idx) => {
    const currentFiles = uploadedFiles.filter((x, i) => i !== idx);
    setUploadedFiles(currentFiles);
  };

  return (
    <Box className="mt-5">
      <div className="m-aut0 text-center border-dotted border-2 border-gray-400 rounded p-5">
        <label htmlFor="rx">
          <div>
            <FileUploadIcon></FileUploadIcon>
          </div>
          <div className="text-gray-500 text-xs font-semibold cursor-pointer">
            Upload Prescription
          </div>
        </label>
      </div>
      <div className="my-2 d-flex justify-content-center flex-column align-items-center">
        {uploadedFiles.map((fileDetails, idx) => (
          <div
            key={idx}
            className="my-2 py-1 px-2"
            style={{
              backgroundColor: "#F6FFDF",
              width: "fit-content",
              position: "relative",
            }}
          >
            {fileDetails.name}
            <div
              style={{ position: "absolute", top: "-7px", right: "-7px" }}
              onClick={() => removeFile(idx)}
            >
              <CancelIcon
                className="text-red-600 mx-2 cursor-pointer"
                style={{ fontSize: "15px" }}
              ></CancelIcon>
            </div>
          </div>
        ))}
      </div>
      <input
        type="file"
        id="rx"
        className="hidden"
        multiple
        name="rx"
        accept=".pdf,image/*"
        onChange={(event) => onFileUpload(event)}
      />
    </Box>
  );
}
